module.exports = __webpack_public_path__ + "static/media/blog.ab22da98.svg";